module.exports = {"attributes":{"width":"12","height":"7","viewBox":"0 0 12 7","xmlns":"http://www.w3.org/2000/svg"},"content":"<title>     Combined Shape   </title>   <path d=\"M5.8 2.2l-4 4.2A1 1 0 0 1 .2 4.9L4.9.3c.3-.2.6-.3 1-.3.2 0 .6 0 .8.3l4.7 4.6a1 1 0 0 1-1.5 1.5L6 2.2z\" fill-rule=\"evenodd\"/>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/new-arrow-up.svg
// module id = 1424
// module chunks = 0